import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  customizeButton: {
    padding: theme.spacing(0, 4),
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    borderRadius: theme.shape.borderRadius,
    transition: 'all 0.2s',
    height: 38,
    backgroundColor: theme.palette.common.white,
  },
}));
function CustomizeButton({ setActiveScreen }) {
  const classes = useStyles();

  return (
    <Button
      variant="outlined"
      className={classes.customizeButton}
      data-test-id="consent-customize"
      onClick={() => setActiveScreen('customize')}
    >
      Customize
    </Button>
  );
}

CustomizeButton.propTypes = {
  setActiveScreen: PropTypes.func.isRequired,
};

export default CustomizeButton;
